import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment } from "react";
import { FormEvent, useState } from "react";
import { Button, Form, FormControl, InputGroup, Modal, Spinner } from "react-bootstrap";
import SEGESVehicle, { ISEGESVehicleResource } from "../../../models/segesVehicle";
import TypeSelector from "./TypeSelector";

interface Props {
    vehicle: ISEGESVehicleResource;
    onDeleted?: (vehicle: ISEGESVehicleResource) => void;
  }
  const Delete: React.FC<Props> = ({ vehicle, onDeleted }) => {
    const [loading, setLoading] = useState(false);
    const [shown, setShown] = useState(false);
    const deleteVehicle = async () => {
      try {
        setLoading(true);
        await SEGESVehicle.Delete(vehicle)
        setLoading(false);
        setShown(false);
        if (onDeleted) {
          onDeleted(vehicle);
        }
      } catch (error) {
        console.error(error);
      }
    };
    const formDelete = async (event: FormEvent) => {
      event.preventDefault();
      await deleteVehicle();
    };
    return (
      <Fragment>
        <button
          title="Slet SEGES køretøj"
          className="blank-button"
          onClick={() => setShown(true)}
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
  
        <Modal show={shown} onHide={() => setShown(true)}>
          <form onSubmit={formDelete}>
            <Modal.Title>Slet SEGES køretøj</Modal.Title>
            <Modal.Body>
              {vehicle.vehicle && (
                  <Form.Group>
                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text>Køretøj</InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl readOnly={true} defaultValue={`${vehicle.vehicle.alias}, ${vehicle.vehicle.licensePlate}`} />
                  </InputGroup>
                </Form.Group>
              )}
              <Form.Group>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>Type</InputGroup.Text>
                  </InputGroup.Prepend>
                  <TypeSelector disabled value={vehicle.type} />
                </InputGroup>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="warning" disabled={loading} type="submit">
                Slet {loading && <Spinner animation="border" size="sm" />}
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  setShown(false);
                }}
              >
                Luk
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </Fragment>
    );
  };
  
  export default Delete;